import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function orFragment(v, cond) {
    if (!cond)
        return _jsx(_Fragment, {});
    else
        return v;
}
